import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import type { DateString } from '@/types/api';
import type { Appointment, RecurrencePattern } from '@/types/scheduling';
import { useMutation } from '@tanstack/react-query';

export interface RecurringSettings {
  recurrencePattern: RecurrencePattern;
  endDate: DateString;
}

export interface RescheduleRecurringAppointmentBody {
  appointmentId: string;
  studentId: number;
  enrollmentId: number;
  targetDate: DateString;
  recurringSettings: RecurringSettings;
  isPlan: boolean;
}

export interface RescheduleRecurringAppointmentResponse {
  notpossible_appointments?: { date: DateString }[];
  notBookedAppointments?: { date: DateString }[];
  booked_appointments?: Appointment[];
}

export const rescheduleRecurringAppointment = async (data: RescheduleRecurringAppointmentBody): Promise<RescheduleRecurringAppointmentResponse> => {
  const response = await apiClient.post<RescheduleRecurringAppointmentResponse>('/v1/scheduling/reschedule-appointments', data);
  return response.data;
};

interface UseRescheduleRecurringAppointmentOptions {
  options?: MutationOptions<RescheduleRecurringAppointmentResponse, RescheduleRecurringAppointmentBody>;
}

export const useRescheduleRecurringAppointment = ({ options }: UseRescheduleRecurringAppointmentOptions = {}) => {
  return useMutation({
    mutationKey: ['rescheduleRecurringAppointment'],
    mutationFn: rescheduleRecurringAppointment,
    ...options,
  });
};
